// extracted by mini-css-extract-plugin
export default {"collectionHeading":"l2ARk","collectionRow":"dgWQG"};